/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCsc } from '../../factoriesAny.js';
export var cscDependencies = {
  BigNumberDependencies,
  typedDependencies,
  createCsc
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesCsc.generated.js
// module id = 1341
// module chunks = 2